import { FC } from 'react'
import { Icon, MenuItem } from 'ui'
import FlagIcon from '/public/s2_icon_flag.svg'
import {
  useProjectCardActions,
  useProjectCardState
} from '@hooks/useProjectCard'
import { captureException } from '@sentry/nextjs'
import AdobeIMS from '@services/auth/IMS'
import { useAuth } from '@hooks/useAuth'
import { useTranslations } from 'use-intl'

type Props = {
  projectUuid: string
  ownerAdobeUserId?: string
}

export const ReportButton: FC<Props> = ({ projectUuid, ownerAdobeUserId }) => {
  const {
    openReportForm,
    setProjectUuidToReport,
    setOwnerAdobeUserIdToReport
  } = useProjectCardActions()
  const { promptLogin } = useAuth()
  const t = useTranslations()
  const reportFormVisible = useProjectCardState('reportFormVisible')

  const handleOnClick = () => {
    const isAuthenticated = AdobeIMS.isSignedInUser()

    if (!projectUuid) {
      console.error('Project uuid not defined')
      captureException(
        'Project uuid not defined when project was being reported'
      )

      return
    }

    if (typeof ownerAdobeUserId === 'undefined') {
      console.error('ownerUserUuid is not defined')
      captureException(
        'Content creator uuid not defined when project was being reported'
      )

      return
    }

    if (!isAuthenticated) return promptLogin({ authenticationMethod: 'MODAL' })

    if (!reportFormVisible) {
      setProjectUuidToReport(projectUuid)
      setOwnerAdobeUserIdToReport(ownerAdobeUserId)
    }

    openReportForm()
  }

  return (
    <MenuItem
      id="report-project-trigger"
      onClick={handleOnClick}
      disabled={reportFormVisible}>
      <Icon slot="icon" className="icon-m">
        <FlagIcon />
      </Icon>
      {t('dashboard:projectCard:menu:report')}
    </MenuItem>
  )
}
